module.exports = __webpack_public_path__ + "img/certificate-2.d2c99888.png";